import React from 'react';
import { Box, Button, Typography } from '@heycater/design-system';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

function StepsToCatering({ cta, link }) {
  const { t } = useTranslation('static_pages');

  return (
    <Box my={{ xs: 6, sm: 10 }}>
      <Box mb={{ xs: 4, sm: 6 }} px={{ xs: 5, md: 0 }}>
        <Typography variant="h3" textAlign="center" xs={{ lineHeight: 1.5 }}>
          {t('customerLandingPage.stepsToCatering.title')}
        </Typography>
      </Box>
      <StepsToCateringContent>
        <StepsToCateringItem>
          <IconWrapper>
            <Image
              alt=""
              src="/artifacts/images/marketing_pages/customer-city.webp"
              width={116.75}
              height={104}
            />
          </IconWrapper>
          <Box
            px={2}
            flex={1}
            sm={{ textAlign: 'center' }}
            pb={{ xs: 3, md: 4 }}
          >
            <Typography variant="body1" fontWeight={600}>
              {t('customerLandingPage.stepsToCatering.cityTitle')}
            </Typography>
            <Typography variant="body1" px={{ sm: 3, md: 10 }}>
              {t('customerLandingPage.stepsToCatering.cityBody')}
            </Typography>
          </Box>
        </StepsToCateringItem>

        <StepsToCateringItem>
          <IconWrapper>
            <Image
              alt=""
              src="/artifacts/images/marketing_pages/customer-compare.webp"
              width={116.75}
              height={104}
            />
          </IconWrapper>

          <Box
            px={2}
            flex={1}
            sm={{ textAlign: 'center' }}
            pb={{ xs: 3, md: 4 }}
          >
            <Typography variant="body1" fontWeight={600}>
              {t('customerLandingPage.stepsToCatering.compareTitle')}
            </Typography>
            <Typography variant="body1" px={{ sm: 3, md: 12 }}>
              {t('customerLandingPage.stepsToCatering.compareBody')}
            </Typography>
          </Box>
        </StepsToCateringItem>

        <StepsToCateringItem>
          <IconWrapper>
            <Image
              alt=""
              src="/artifacts/images/marketing_pages/customer-enjoy.webp"
              width={116.75}
              height={104}
            />
          </IconWrapper>

          <Box
            px={2}
            flex={1}
            sm={{ textAlign: 'center' }}
            pb={{ xs: 3, md: 4 }}
          >
            <Typography variant="body1" fontWeight={600}>
              {t('customerLandingPage.stepsToCatering.enjoyTitle')}
            </Typography>
            <Typography variant="body1" px={{ sm: 3, md: 10 }}>
              {t('customerLandingPage.stepsToCatering.enjoyBody')}
            </Typography>
          </Box>
        </StepsToCateringItem>
      </StepsToCateringContent>
      <Box textAlign="center" mt={1}>
        <Button
          size="lg"
          rounded
          id="steps-to-catering-button"
          as="a"
          href={link}
          target="_blank"
        >
          {cta}
        </Button>
      </Box>
    </Box>
  );
}

function IconWrapper({ children }) {
  return (
    <Box mb={{ xs: 0, md: 0, lg: 2 }} display="flex" justifyContent="center">
      {children}
    </Box>
  );
}

const StepsToCateringContent = styled.div`
  display: flex;
  ${(props) => props.theme.breakpoints.down('sm')} {
    flex-wrap: wrap;
    justify-content: center;
  }
  ${(props) => props.theme.breakpoints.down('xs')} {
    flex-direction: column;
    padding: ${(props) => props.theme.spacing(0, 8, 0, 8)};
  }
`;

const StepsToCateringItem = styled.div`
  width: 33%;
  text-align: center;
  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 33%;
  }
  ${(props) => props.theme.breakpoints.down('xs')} {
    width: 100%;
    display: flex;
    text-align: center;
    flex-direction: column;
  }
`;

export default StepsToCatering;
